import React, {Component} from 'react';
import {getAllPeople, getTeam, insertOrUpdateTeam} from '../../util/APIUtils';
import {SESSION_USER} from '../../constants';
import NotFound from '../../common/NotFound';
import ServerError from '../../common/ServerError';
import Loading from '../../common/Loading';
import {Field, reduxForm} from 'redux-form';
import {Provider} from "react-redux";
import Store from '../../helpers/Store';
import {inputField, selectField, textAreaField} from '../../helpers/Error';

const validate = (values, props) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Crew name is required'
    }
    if (values.peoples.length === 0) {
        errors.peoples = 'Employee is required'
    }
    return errors
};

class teamForm extends React.Component {

    /*constructor(props) {
        super(props);
    }*/

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="form-body">
                    <div className="row p-t-20">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Crew Name </label>
                                <Field type="text" className="form-control" name="name"
                                       fieldValue={this.props.states.name} component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>
                     <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Zoho Id</label>
                              <Field type="text" className="form-control" name="zohoId"
                                       fieldValue={this.props.states.zohoId} component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>   <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Status</label>
                              <Field type="text" className="form-control" name="status"
                                       fieldValue={this.props.states.status} component={inputField}
                                       onChange={this.props.changeState}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Description</label>
                                <Field rows="3" cols="24" component={textAreaField} name="description"
                                       className='form-control' id="description" value={this.props.states.description}
                                       onChange={this.props.handleChange}/>
                            </div>
                        </div>
                    </div>
                    <h3 className="box-title m-t-40">Crew Feature</h3>
                    <hr/>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">Employee </label>
                                <Field valueKey="value" isMulti options={this.props.states.optionTeamList}
                                       value={this.props.states.peoples} name="peoples" id="peoples"
                                       component={selectField}
                                       onChange={this.props.selectPeopleChange}/>
                            </div>
                        </div>

                    </div>
                </div>
                <Field type="hidden" name="id" id="id" fieldValue={this.props.states.id} component={inputField}/>
                <div className="form-actions">
                    <button type="submit" className="btn btn-primary btn-rounded"><i className="fa fa-check"></i> Save</button>
                    &nbsp;&nbsp;&nbsp;
                    <a href="/teams" className="btn btn-inverse btn-rounded">Cancel</a>
                </div>
            </form>
        );
    }
}

const TeamForm = reduxForm({
    form: 'team_form',
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    updateUnregisteredFields: true,
    validate
})(teamForm);

class TeamFormComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: '',
            name: '',
            zohoId:'',
            description: '',
            status:'1',
            optionTeamList: [],
            peoples: [],
            loading: true
        }
        this.handleChange = this.handleChange.bind(this);
        this.peoplelist = this.peoplelist.bind(this);
        this.loadteam = this.loadteam.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const teamId = this.props.match.params.teamId;
        if (teamId > 0) {
            this.loadteam(teamId);
        } else {
            this.setState({loading: false});
        }
        this.peoplelist();
    }

    componentDidUpdate(nextProps) {
        if (this.props.match.params.teamId !== nextProps.match.params.teamId) {
            this.loadteam(nextProps.match.params.teamId);
        }
    }

    loadteam(teamId) {
        getTeam(teamId)
            .then(response => {
                console.log(response);

                var selectedpeoples = [];
                if (response.peoples) {
                    for (var k in response.peoples) {
                        var people = response.peoples[k];
                        if (people.isDeleted === 1)continue;
                        var selectedPeople = {value: people.id, label: people.firstName+" "+people.lastName};
                        selectedpeoples.push(selectedPeople);
                    }
                }

                this.setState({
                    name: response.name,
                    description: response.description,
                    id: response.id,
                    zohoId:response.zohoId,
                    status:response.status,
                    peoples: selectedpeoples,
                    loading: false
                });

            }).catch(error => {
            if (error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });

    }

    peoplelist() {
        let user = JSON.parse(localStorage.getItem(SESSION_USER));
        getAllPeople(user.id)
            .then(response => {

                var teamarray = [];
                for (var k in response) {
                    teamarray.push({label: response[k].firstName + ' ' + response[k].lastName, value: response[k].id})
                }
                this.setState({optionTeamList: teamarray});


            }).catch(error => {
            if (error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });
    }

    handleChange(event) {
        const target = event.target;
        const inputValue = target.value;
        this.setState({
            [target.name]: inputValue
        });
    }

    onSelectPeopleChange(value) {
        const target = value;
        console.log(target);
        if (!this.state.loading) {
            this.setState({peoples: target});
        }

    }


    handleSubmit(values, dispatch) {
        //event.preventDefault();
        const fields = values;
        let user = JSON.parse(localStorage.getItem(SESSION_USER));
        fields["userId"] = user.id;

        if (fields['peoples']) {
            var peoplearray = [];
            var peoples = fields['peoples'];
            for (var k in peoples) {
                peoplearray.push(peoples[k].value);
            }
            fields['peoples'] = peoplearray;
            console.log(fields);
        }
        //  return false;
        insertOrUpdateTeam(fields)
            .then(response => {
                this.props.history.push("/teams");
            }).catch(error => {
            this.setState({
                serverError: true,
            });
        })

    }

    render() {


        if (this.state.notFound) {
            return <NotFound />;
        }

        if (this.state.serverError) {
            return <ServerError />;
        }

        if (this.state.loading) {
            return <Loading />;
        }

      

        return (
            <div>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor m-b-0 m-t-0">Crew Form</h3>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Home</li>
                            <li className="breadcrumb-item active">Crew</li>
                        </ol>
                    </div>
                    <div className="col-md-7 col-4 align-self-center">
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card card-outline-info">
                            <div className="card-header">
                                <h4 className="m-b-0 text-white">Crew form</h4>
                            </div>
                            <div className="card-body">

                                <Provider store={Store}>
                                    <TeamForm changeState={this.handleChange} states={this.state}
                                              initialValues={this.state}
                                              selectPeopleChange={this.onSelectPeopleChange.bind(this)}
                                              onSubmit={this.handleSubmit.bind(this)}/>
                                </Provider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default TeamFormComponent;